module.exports = __webpack_public_path__ + "img/2.fe481b36.png";